import React from 'react';
import { LoginFormStyled } from './styled';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Inputs, Buttons } from 'components';

const LoginForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <LoginFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="f_title">Sign in to CONTROL</div>
        <div className="input_wrap mb_24">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.InputLineBottom
                {...field}
                label="Email/Phone"
                placeholder="admin@mail.com"
                errors={errors.username?.message}
              />
            )}
            name="username"
            defaultValue=""
          />
        </div>
        <div className="input_wrap mb_24">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.InputLineBottom
                {...field}
                type="password"
                label="Password"
                placeholder="Password"
                errors={errors.password?.message}
              />
            )}
            name="password"
            defaultValue=""
          />
        </div>
        <Buttons.BtnNormal label="Sign in" type="submit" />
      </form>
    </LoginFormStyled>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
